import Basic from './basic.vue';
import MobBasic from '@rebuild/materials/shared/layout_wrapper/flowX/standard/MobBasicCore.vue';

export const componentMap = {
	basic: Basic,
	'mob-basic': MobBasic
};
